import React from 'react';
import OfficeBuildingFilledIcon from '@atlaskit/icon/core/migration/office-building--office-building-filled';
import PeopleIcon from '@atlaskit/icon/core/migration/people-group--people';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { messages } from '../../messages.tsx';
import type { CustomerSupportManagementSectionProps } from './types.tsx';

/**
 * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4/jsm-project-menu
 */
export const CustomerSupportManagementItems = ({
	urlPath,
	// currently not used but can be in the future for premium/non-premium features
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	isPremiumTenant,
}: CustomerSupportManagementSectionProps) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<MenuItem
				analytics={{ itemId: 'organizations' }}
				href={`${urlPath}/organizations`}
				iconBefore={<OfficeBuildingFilledIcon spacing="spacious" label="" />}
				selectedOn={[
					'servicedesk-organizations',
					'servicedesk-organization-details',
					'servicedesk-organization_v2',
				]}
			>
				{formatMessage(messages.itemOrganizations)}
			</MenuItem>
			<MenuItem
				analytics={{ itemId: 'customers' }}
				href={`${urlPath}/customers`}
				iconBefore={<PeopleIcon spacing="spacious" label="" />}
				selectedOn={['servicedesk-customers-v2']}
			>
				{formatMessage(messages.itemIndividuals)}
			</MenuItem>
		</>
	);
};
